import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { CenteredRowContainer } from 'components/ui/centered-row-container';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { primitive, spacing } from 'styles/constants';

// TODO: loading state for SimpleHomePage. It would be updated to the new design.
export const HeroSkeleton = () => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <CenteredRowContainer standardPadding containerStyle={styles.background}>
      <Box style={[styles.skeletonWrapper, isDesktop && styles.skeletonWrapperDesktop]}>
        <Box style={[styles.imageColumn, isDesktop && styles.imageColumnDesktop]}>
          <Skeleton h="$48" w="$48" mb="$3" rounded="full" mx="auto" />
        </Box>
        <Box style={[styles.textColumn, isDesktop && styles.textColumnDesktop]}>
          <Skeleton.Text mb="$4" />
          <Skeleton
            h="$10"
            rounded="full"
            mb="$2"
            startColor="token.background-skeleton-loader-cta-start"
            endColor="token.background-skeleton-loader-cta-end"
          />
        </Box>
      </Box>
    </CenteredRowContainer>
  );
};

const styles = StyleSheet.create({
  background: {
    backgroundColor: primitive.$mayoEggWhite,
  },
  skeletonWrapper: {
    paddingVertical: spacing.$4,
  },
  skeletonWrapperDesktop: {
    flexDirection: 'row-reverse',
    paddingVertical: spacing.$8,
  },
  imageColumn: {
    padding: spacing.$6,
    width: '100%',
  },
  imageColumnDesktop: {
    width: '50%',
  },
  textColumn: {
    justifyContent: 'center',
    width: '100%',
  },
  textColumnDesktop: {
    width: '50%',
  },
});
